

/*
 Artist / Artwork Wishlist Button
*/
const CUSTOM_ARTIST_WISHLIST_OPTIMISTIC_DISABLE_MS = 500;

function disableArtistWishlistButtonTemporarily(element, duration = CUSTOM_ARTIST_WISHLIST_OPTIMISTIC_DISABLE_MS) {
  if (!element) return;
  element.disabled = true;
  if (element._multilikesDisableTimer) {
    clearTimeout(element._multilikesDisableTimer);
  }
  element._multilikesDisableTimer = setTimeout(() => {
    element.disabled = false;
    element._multilikesDisableTimer = null;
  }, duration);
}

function adjustArtistWishlistFavoriteCount(currentCount, wasFavorited, isFavorited) {
  const parsed = Number(currentCount);
  if (Number.isNaN(parsed) || wasFavorited === isFavorited) {
    return Number.isNaN(parsed) ? 0 : Math.max(0, parsed);
  }
  return isFavorited ? Math.max(0, parsed) + 1 : Math.max(0, parsed - 1);
}

const ARTIST_FAVORITE_TEXT_ADD = 'お気に入りに登録';
const ARTIST_FAVORITE_TEXT_REMOVE = 'お気に入りから削除';

class ArtistWishlistButton {
  constructor(button) {
    this.button = button;
    this.objectType = button.dataset.objectType || 'artist';
    this.objectId = button.dataset.objectId;
    this.customerId = button.dataset.customerId;
    this.favoriteCount = 0;
    this.requestSeq = 0;
    this.pendingRequestCount = 0;
    this.finalSyncTimer = null;
    
    // Config fallback: use window.multilikesConfig or default app proxy
    this.defaultUrl = window.multilikesConfig?.defaultUrl;
    
    if (this.customerId) {
      this.init();
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleFavorite();
      });
    } else {
       // ログインしていない場合はログインページへ遷移
       this.button.addEventListener('click', (e) => {
         e.preventDefault();
         // 未ログインの理由を示してから誘導する
         if (typeof window.requireLoginForWishlist === 'function') {
           window.requireLoginForWishlist();
           return;
         }
         window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.href);
       });
    }
  }

  async init() {
    await this.fetchLatestData();
    this.updateFavoriteCountElement();
  }

  async fetchLatestData(options = {}) {
    try {
      const params = new URLSearchParams({
        customer_id: this.customerId,
        type: this.objectType,
        metaobject_id: this.objectId
      });

      const response = await fetch(`${this.defaultUrl}?${params.toString()}`);
      if (!response.ok) return;
      const result = await response.json();
      console.log("fetchLatestData::result",result);

      if (options.syncSeq !== undefined && options.syncSeq !== this.requestSeq) {
        return;
      }

      const item = result.data;
      
      if (item) {
        // カウントを取得
        this.favoriteCount = this.getFavoriteCountFromItem(item);

        console.log("fetchLatestData::favoriteCount",this.favoriteCount);
        // 現在のステータス（Liquidで設定されたクラス）を維持しつつ、カウントを反映
        const isFavorited = this.button.classList.contains('is-active');
        this.updateButton(isFavorited);
      }

    } catch (e) {
      console.error('Error fetching artist wishlist data:', e);
    }
  }

  getFavoriteCountFromItem(item) {
    let count = item.favoriteCount;
    
    // プロパティにない場合はfieldsから探す
    if (typeof count !== 'number' && item.fields && Array.isArray(item.fields)) {
      const field = item.fields.find(f => f.key === 'favorite_count');
      if (field) {
        count = field.value ?? field.jsonValue;
      }
    }
    
    // 数値変換
    if (count === null || count === undefined) return 0;
    const num = Number(count);
    return Number.isNaN(num) ? 0 : Math.max(0, num);
  }

  resolveFavoriteCountFromPayload(payload) {
    if (!payload) return null;
    const count = payload.favoriteCount ?? payload.updatedCount;
    if (count !== null && count !== undefined) {
      const num = Number(count);
      return Number.isNaN(num) ? null : Math.max(0, num);
    }

    if (payload.fields && Array.isArray(payload.fields)) {
      const field = payload.fields.find(f => f.key === 'favorite_count');
      const fieldValue = field?.value ?? field?.jsonValue;
      if (fieldValue !== null && fieldValue !== undefined) {
        const num = Number(fieldValue);
        return Number.isNaN(num) ? null : Math.max(0, num);
      }
    }

    return null;
  }

  nextRequestSeq() {
    this.requestSeq += 1;
    return this.requestSeq;
  }

  isLatestRequest(seq, objectId = this.objectId) {
    return seq === this.requestSeq && objectId === this.objectId;
  }

  scheduleFinalSync() {
    if (this.finalSyncTimer) {
      clearTimeout(this.finalSyncTimer);
    }
    this.finalSyncTimer = setTimeout(() => {
      this.finalSyncTimer = null;
      if (this.pendingRequestCount === 0 && this.customerId) {
        this.fetchLatestData({ syncSeq: this.requestSeq });
      }
    }, 0);
  }

  async toggleFavorite() {
    const previousState = this.button.classList.contains('is-active');
    const previousCount = this.favoriteCount;
    const nextState = !previousState;
    const action = nextState ? 'add' : 'remove';
    const requestObjectId = this.objectId;
    const seq = this.nextRequestSeq();
    this.pendingRequestCount += 1;

    this.favoriteCount = adjustArtistWishlistFavoriteCount(previousCount, previousState, nextState);
    this.updateButton(nextState);
    disableArtistWishlistButtonTemporarily(this.button);


    try {
      const response = await fetch(this.defaultUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          customer_id: this.customerId,
          metaobject_type: this.objectType,
          target_type: 'metaobject',
          metaobject_id: requestObjectId,
          action: action
        })
      });

      const result = await response.json();

      if (!this.isLatestRequest(seq, requestObjectId)) {
        if (!response.ok) {
          console.error('Stale artist wishlist update failed:', result);
        }
        return;
      }

      if (response.ok) {
        const payload = result?.data || {};
        const resolvedCount = this.resolveFavoriteCountFromPayload(payload);
        if (resolvedCount !== null) {
          this.favoriteCount = resolvedCount;
        }

        // 成功したらステータスを更新
        this.updateButton(
          typeof payload.isInWishlist === 'boolean' ? payload.isInWishlist : nextState
        );
      } else {
        throw new Error(result?.error || 'Failed to update artist wishlist');
      }
    } catch (e) {
      if (this.isLatestRequest(seq, requestObjectId)) {
        this.favoriteCount = previousCount;
        this.updateButton(previousState);
        alert('エラーが発生しました。');
      } else {
        console.error('Stale artist wishlist update failed:', e);
      }
    } finally {
      this.pendingRequestCount = Math.max(0, this.pendingRequestCount - 1);
      if (this.pendingRequestCount === 0) {
        this.scheduleFinalSync();
      }
    }
  }

  updateButton(isFavorited) {
    if (isFavorited) {
      if(this.button.classList.contains("has-icon") !== true) {
        this.button.textContent = ARTIST_FAVORITE_TEXT_REMOVE;
      }
      this.button.classList.add('is-active');
      this.button.classList.add('remove-favorite');
      this.button.classList.remove('add-favorite');
    } else {
      if(this.button.classList.contains("has-icon") !== true) {
        this.button.textContent = ARTIST_FAVORITE_TEXT_ADD;
      }
      this.button.classList.remove('is-active');
      this.button.classList.add('add-favorite');
      this.button.classList.remove('remove-favorite');
    }

    this.updateFavoriteCountElement();
  }

  updateFavoriteCountElement() {
    if (this.favoriteCount === undefined || this.favoriteCount === null) return;

    const countEl = document.querySelector(
      `.multilikes-artist-favorites-count[data-object-type="${this.objectType}"][data-object-id="${this.objectId}"]`
    );
    if (countEl) {
      countEl.textContent = this.favoriteCount;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
   const btnList = document.querySelectorAll('.c-artist-block__button');
   if(btnList) {
     btnList.forEach(btn => {
       new ArtistWishlistButton(btn);
     });
   }
});
